import {
  AccountCircleSharp,
  Article,
  Logout,
  Menu as MenuIcon,
} from "@mui/icons-material";
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import { userGuideDoc } from "utility/constants";

const drawerWidth = 250;

const TopAppBar = ({ handleDrawerToggle, logout, userInfo }: any) => {
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
  const theme = useTheme();

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  
  return (
    <AppBar
      position="absolute"
      id="topbar"
      sx={{
        width: { sm: `100%` },
        ml: { sm: `${drawerWidth}px` },
      }}
    >
      <Toolbar style={{ backgroundColor: "white" }}>
        <Box flexGrow={1} display={"flex"} alignItems={"center"}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 1 }}
          >
            <MenuIcon 
            style={{ color: "#ff6c30" }}
            />
          </IconButton>
          <Box sx={{ mt: 1 }}>
            
          </Box>
          <Typography variant="h6" noWrap component="div">
          <div style={{ padding: "8px" }}><img src="https://www.ascentt.com/wp-content/uploads/thegem-logos/logo_3ecf80c1978fe47f22d64bd6da182d45_1x.png" alt="Ascentt INC"/></div>
          </Typography>
        </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Access the user guide">
              <Button
                variant="text"
                startIcon={<Article />}
                sx={{ color: theme.palette.primary.contrastText }}
                onClick={() => {
                  window.open(
                    userGuideDoc,
                    "_blank"
                  );
                }}
                style={{ color: "#ff6c30" }}
              >
                User Guide
              </Button>
            </Tooltip>
          </Box>
        <Divider
          orientation="vertical"
          sx={{
            paddingRight: 1,
            paddingLeft: 1,
            backgroundColor: theme.palette.primary.contrastText,
          }}
        />
        <Typography style={{ color: "#ff6c30" }} ml={1} fontWeight={"bold"} >{userInfo?.email}</Typography>
        <Box sx={{ flexGrow: 0, color: "#ff6c30" }} ml={1} >
          <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
            <Avatar sx={{ bgcolor: "#ff6c30" }}>
              <AccountCircleSharp fontSize={"large"} />
            </Avatar>
          </IconButton>
          <Menu
            sx={{ width: "500px", color: "#ff6c30" }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            keepMounted
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            <MenuItem onClick={logout}>
              <Logout />
              <Typography ml={1}>Logout</Typography>
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};
export default TopAppBar;
